import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { PrivacyOverlay } from './privacyOverlay.component';
import { selectIsOverlayStandalone, selectIsPrivacyVisible, OverlayActions } from '../../../modules/overlay';
import { LegalActions, selectPrivacyPolicyContent } from '../../../modules/legal';

const mapStateToProps = createStructuredSelector({
  content: selectPrivacyPolicyContent,
  isVisible: selectIsPrivacyVisible,
  isStandalone: selectIsOverlayStandalone,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showOverlay: OverlayActions.showPrivacy,
      hideOverlay: OverlayActions.hideOverlay,
      fetchPrivacy: LegalActions.fetchPrivacyPolicy,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(PrivacyOverlay);
